import React from 'react';

import Head from 'next/head';
import NewEventDashboard from 'screens/events/EventDashboard/new/NewEventDashboard';

const EventDashboardScreen = () => (
  <>
    <Head>
      <title>Event Dashboard | Bounce</title>
    </Head>
    <NewEventDashboard />
  </>
);

export default EventDashboardScreen;
